import React, { useEffect,useState } from "react";
import { useParams,useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./MasterclassVideo.css";
import loader from '../../assests/loader.gif';
import API from '../../Utils/Api';
import { Modal } from "react-bootstrap";

const MasterclassVideo = () => {
  const { id } = useParams();
  const [loading,setLoading] = useState(true);
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [inputs, setInputs] = useState({id:'',coach_id:'',name:'',price:'',coach_name:'',image:'',pdf:'',description:'',trailer_video_url:'',mobile_course_trailer_url:'',desktop_image:'',mobile_image:'',video_min:''});

  const [coursereldata, setCoursereldata] = useState([]);
  const [trailerid, setTrailerid] = useState('');
  const [traileridmo, setTraileridmo] = useState('');
  const [cid, setCid] = useState(0);
  const [ordchk, setOrdchk] = useState(0);

  
  useEffect(() => {
    document.title = `MasterclassVideo | Your Friend My Friend`;
    document.getElementById('bodywrap').className = 'brand';

    localStorage.removeItem("prev_page");
    localStorage.removeItem("checkout_data");
    /* Start get course data */
    let formData = new FormData();
    formData.append('id', id);

    var url='get_course_detail';
      if(localStorage.getItem('auth_token'))
      {
        url='get_course_detail_with_login';
      }
      API.post(url,formData)
        .then(response => {
          setLoading(false);
        if(response.data.status === false){
          
        }else{

            var trailer_video_url=response.data.data.trailer_video_url;
            var mobile_course_trailer_url=response.data.data.mobile_course_trailer_url;
            if(response.data.data.is_booked===1)
            {
              trailer_video_url=response.data.data.video_id_url;
              mobile_course_trailer_url=response.data.data.mobile_original_video_url;
            }

           setInputs({
              id:response.data.data.id,
              coach_id:response.data.data.coach_id,
              name:response.data.data.name,
              price:response.data.data.price,
              coach_name:response.data.data.coach_name,
              image:response.data.data.image,
              pdf:response.data.data.pdf,
              description:response.data.data.description,
              trailer_video_url:trailer_video_url,
              mobile_course_trailer_url:mobile_course_trailer_url,
              desktop_image:response.data.data.desktop_image,
              mobile_image:response.data.data.mobile_image,
              video_min:response.data.data.video_min,
           });
           setCoursereldata(response.data.data.course_rel_data);
           if(response.data.data.is_booked===0)
           {

             const savedCart = JSON.parse(localStorage.getItem("cartItems")) || [];
              const isInCart = savedCart.some((item) => item.id === Number(id));
              console.log(isInCart + ' ffffffff');
              
              if (isInCart) {
                setOrdchk(2);
              } else {
                setOrdchk(3);
              }
           }else{
              setOrdchk(1);
           }
           

        }                  
      }).catch(error => {
         setLoading(false);
      });  
     /* End get course data */
  }, [id]);

  
  const setShowtrailerid = (trailer_id,mobile_course_trailer_url,id) => {
      setTrailerid(trailer_id);
      setTraileridmo(mobile_course_trailer_url);
      setCid(id);
      setShow(true);
  }

 const addToCart = (product,coach_id) => {
  const savedCart = JSON.parse(localStorage.getItem("cartItems")) || [];

  const existingItem = savedCart.find(
    (item) => String(item.id) === String(product.id)
  );

  let updatedCart;

  if (existingItem) {
    updatedCart = savedCart.map((item) =>
      String(item.id) === String(product.id)
        ? { ...item, quantity: item.quantity + 1 }
        : item
    );
  } else {
    updatedCart = [...savedCart, { ...product, quantity: 1 }];
  }

  localStorage.setItem("cartItems", JSON.stringify(updatedCart));
  window.location.href = "/coaching-video/"+coach_id;
};


  return (
    <>
      <Header isMasterClass={true} />
      <div className="hello-worldss d-flex justify-content-center align-items-center">
        {/* Desktop Image */}
        <img
          src={inputs.desktop_image}
          alt=""
          className="img-fluid omagu123 d-none d-md-block"
        />
        <img
          src={inputs.mobile_image}
          alt=""
          className="img-fluid omagu123 d-block d-md-none"
        />
      </div>

      <div className="container-fluid ireland" style={{ background: "#ffffff" }}>
        <div className="row g-4">
          <div className="col-md-6 ire-left chukar">
            <h2 className="mb-0">{inputs.name}</h2>
          </div>

          <div className="col-md-1"></div>

          <div className="col-md-5 ire-right">
            <p className="mb-0">
              {inputs.description}
            </p>

            <div className="timinis mt-3 coach-text-main-box">Relationship Coach: {inputs.coach_name} | Time: {inputs.video_min} mins</div>
          
            <div className="mt-1 chimar ">
            {(() => {
              if (ordchk===1) {
                return (<a href={inputs.pdf} className="text-decoration-none" target="_blank" rel="noopener noreferrer">
                  Download takeaways
                </a>)
              }else if (ordchk===2) {
                return (<button ><img
                          src={process.env.REACT_APP_BASE_URL + 'assests/images/right-df.png'}
                          alt="Masterclass"
                          className="img-fluid me-2 mb-1"
                        />
                        added</button>)
              }else if (ordchk===3) {
                return (<button onClick={() => addToCart({ id: inputs.id, name: inputs.name, price: inputs.price,coach_name:inputs.coach_name },inputs.coach_id)}>€{inputs.price} | ADD TO CART</button>)
              }                             
              })()}
          </div>
          </div>
        </div>
      </div>
       <div className="container-fluid ireland mb-5" style={{ background: "#F1E9DF" }}>
        <div className="row text-start nayus g-4 ">
          <h2>How to Get the Most from This Masterclass</h2>
          <div className="col-12 col-md-6 col-lg-3 mb-4">
            <div className="imu-tag">
              <img
                src={process.env.REACT_APP_BASE_URL + 'assests/images/watch.png'}
                alt="watch"
                className="mb-3"
              />
            </div>
            <h5>Watch the Masterclass</h5>
            <p>
              Set aside some quiet time, press play and really immerse
              yourself in the content. Treat it like a session with your coach.
            </p>
          </div>
 
          <div className="col-12 col-md-6 col-lg-3 mb-4">
            <div className="imu-tag">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/download.png'}
              alt="download"
              className="mb-3"
            />
            </div>
            <h5>Download Your One-Page Guide</h5>
            <p>
              Download the PDF summary and keep it on hand as a quick reminder of the
              key insights, tools and takeaways.
            </p>
          </div>
 
          <div className="col-12 col-md-6 col-lg-3 mb-4">
           <div className="imu-tag">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/rewatch.png'}
              alt="rewatch"
              className="mb-3"
            />
            </div>
            <h5>Rewatch and Go Deeper</h5>
            <p>
              Revisit the masterclass a few times to let the ideas sink in and
              notice new details you may have missed the first time.
            </p>
          </div>
 
          <div className="col-12 col-md-6 col-lg-3 mb-4">
            <div className="imu-tag">
            <img
              src={process.env.REACT_APP_BASE_URL + 'assests/images/lifetime.png'}
              alt="lifetime"
              className="mb-3"
            />
            </div>
            <h5>Lifetime Access, At Your Pace</h5>
            <p>
              Come back to the masterclass whenever you need a refresh. Your access
              never expires, so you can learn and implement in your own time.
            </p>
          </div>
        </div>
        <div className="row chimar position-relative">
          <div className="fully-img video-wrapper">
            <iframe
                    title="YouTube video player"
                  src={inputs.trailer_video_url}
                 allow="fullscreen; encrypted-media"
                  allowFullScreen
                className="youtube-video d-none d-md-block video-iframe"
                
                ></iframe>

                  <iframe
                    title="YouTube video player"
                  src={inputs.mobile_course_trailer_url}
                 allow="fullscreen; encrypted-media"
                  allowFullScreen
                className="youtube-video d-block d-md-none video-iframe"
                
                ></iframe>
          </div>
          <div className="text-center mt-5">
            {(() => {
              if (ordchk===1) {
                return (<a href={inputs.pdf} className="text-decoration-none" target="_blank" rel="noopener noreferrer">
                  Download takeaways
                </a>)
              }else if (ordchk===2) {
                return (<button ><img
                          src={process.env.REACT_APP_BASE_URL + 'assests/images/right-df.png'}
                          alt="Masterclass"
                          className="img-fluid me-2 mb-1"
                        />
                        added</button>)
              }else if (ordchk===3) {
                return (<button onClick={() => addToCart({ id: inputs.id, name: inputs.name, price: inputs.price,coach_name:inputs.coach_name },inputs.coach_id)}>€{inputs.price} | ADD TO CART</button>)
              }                             
              })()}
          </div>
        </div>
      </div>
      <div className="container-fluid discover up-even disroveru pt-4 lo-oma" style={{ background: "#FFF" }}>
        <div className="text-center topa-top mb-4">Other videos in this series</div>
        <div className="row justify-content-center">
          {coursereldata.map((val, i) => (
          <div className="col-md-4 mb-4 joker pocho">
            <div className="card vesi h-100 d-flex flex-column">
              <Link
                to=""
                className="text-decoration-none"
              >
                <img
                  src={val.image}
                  className="card-img-top"
                  alt=""
                />
              </Link>
              <div className="card-body nanu d-flex flex-column">
                <h5><img src={process.env.REACT_APP_BASE_URL + 'assests/images/bubble-frame.png'} className="img-fluid w-auto h-auto" alt="" style={{ width: "14px", minHeight: "22px", marginRight: "10px" }} />{inputs.coach_id===1 ? 'Suggested for Ladies' : 'Suggested for Men' }</h5>
                <p>{val.name}</p>

                <div className="mt-auto purch-his koi">
                  <Link to="" className="sec-fra w-100 text-center" onClick={() => setShowtrailerid(val.trailer_video_url,val.mobile_course_trailer_url,val.id)}>
                    <div className="masterclass">Watch trailer</div>
                  </Link>
                  <button className="btn w-100 mt-0" onClick={() => navigate(`/master-class-video/${val.id}`)}>
                    View masterclass
                  </button>
                </div>
              </div>
            </div>
          </div>
          ))}
          
        </div>
      </div>
      <Modal show={show} onHide={() => setShow(false)} centered size="lg" dialogClassName="custom-modal-nyt">
             <Modal.Header closeButton>Why modern women feel disconnected in love — and how to come home to yourself</Modal.Header>
              <Modal.Body className="text-center">
                <div className="position-relative mb-4">
                  <iframe
                    title="YouTube video player"
                  src={trailerid}
                 allow="encrypted-media"
                allowfullscreen
                style={{
                border: 'none',
                borderRadius: '15px'
              }}
              className="pop-youtube-video d-none d-md-block"
                ></iframe>
                  
                  <iframe
                    title="YouTube video player"
                  src={traileridmo}
                 allow="encrypted-media"
                allowfullscreen
                style={{
                border: 'none',
                borderRadius: '15px'
              }}
              className="pop-youtube-video d-block d-md-none"
                ></iframe>

                </div>

                <div className="d-flex justify-content-center gap-2 flex-wrap juma purch-his">
                  <button className="btn budha mt-0" onClick={() => (window.location.href = `/master-class-video/${cid}`)}>
                    get masterclass
                  </button>
                </div>
              </Modal.Body>
            </Modal>
      {loading && (
         <div className="loadingClass">
          <img src={loader} alt="loader"/>
        </div>
         )}
      <Footer />
    </>
  );
};

export default MasterclassVideo;
